import { request2 } from "../request2";

export const getAllPointsHistorys = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/points/history',
		params
	})
}
export const deletePointsActions = (id) => {
	return request2({
		method: 'get',
		url: `/dashboard/points/action/delete/${id}`,
	})
}
export const addPointsRecord = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/points/action/add',
		params
	})
}